/**

Copyright (c) 2018, MOBICOOP. All rights reserved.
This project is dual licensed under AGPL and proprietary licence.

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.
This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.
You should have received a copy of the GNU Affero General Public License
along with this program. If not, see <gnu.org/licenses>.

Licence MOBICOOP described in the file
LICENSE
**************************/

<template>
  <div class="ion-page">
    <ion-header no-border>
      <ion-toolbar color="primary">
        <ion-buttons slot="start">
          <ion-back-button default-href="/carpools/home"></ion-back-button>
        </ion-buttons>
        <h1 class="ion-text-center">{{ $t('Prime.title') }} </h1>
        <ion-buttons v-if="!!infoUrl" slot="end">
          <a :href="infoUrl" target="_blank" style="color: white">
            <ion-button>
             <ion-icon slot="icon-only" name="information-circle"></ion-icon>
            </ion-button>
          </a>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <ion-content color="primary" no-bounce>
      <div class="mc-white-container ">
        <div class="mc-prime-container">

          <div v-if="step == 1">
            <div class="d-flex" justify-content-center>
              <ion-text color="primary"><b>{{ $t('Prime.inscription')}}</b></ion-text>
            </div>
            <div class="d-flex" justify-content-center="">
                <div class="dot active"></div>
                <div class="dot"></div>
                <div class="dot"></div>
            </div>
            <br>
            <div style="line-height: 20px">
                {{ $t('Prime.inscription-desc', [$t('Prime.EEC-provider')])}}
                <ul style="padding-inline-start: 12px; line-height: 20px">
                  <li><div class="d-flex" justify-content-between="" align-items-center=""><div>{{ $t('Prime.informations-desc-3-start')}} <a @click="$router.push('update-profile')">{{ $t('Prime.informations-desc-3')}}</a></div> <ion-icon style="font-size: 18px" slot="end" color="success" v-if="user.phoneValidatedDate" name="checkmark"></ion-icon></div></li>
                  <li><div class="d-flex" justify-content-between="" align-items-center=""><div>{{ $t('Prime.informations-desc-4-start')}} <a @click="$router.push('update-profile')">{{ $t('Prime.informations-desc-4')}}</a> <ion-icon color="primary" v-on:click="$router.push('info-permis')"slot="icon-only" name="information-circle"></ion-icon>
                  </div> <ion-icon style="font-size: 18px" slot="end" color="success" v-if="user.drivingLicenceNumber" name="checkmark"></ion-icon></div></li>
                </ul>
            </div>
            <br>

            <div>
              {{$t('Prime.inscription-desc-2', [$t('Prime.EEC-platform')] )}}
            </div>
            <div v-if="!!infoUrl">
              <small><a style="color: black" :href="infoUrl">{{$t('Prime.inscription-show-more')}}</a></small>
            </div>
            <br>
            <!--
            <ion-item class="item-background">
              <ion-label position="floating">{{$t('Prime.license')}} *</ion-label>
              <ion-input
                type="text"
                :placeholder="$t('Prime.license') + '*'"
                :value="driverLicense"
                @input="driverLicense = $event.target.value"
              >
              </ion-input>
            </ion-item>
            <br>
            -->


            <div class="signin">
              <div>
                {{$t('Prime.pre-signin', [$t('Prime.EEC-platform'), $t('Prime.EEC-provider')])}}
              </div>
              <div>
                {{$t('Prime.signin')}}
              </div>
              <ion-item class="item-background" lines="none" align-items-start>
                <ion-checkbox :disabled="!(user.phoneValidatedDate && user.drivingLicenceNumber)" slot="start" lines="none" :checked="checks[0]" @ionChange="switchCheck(0)"
                ></ion-checkbox>
                <ion-label class="no-white-space"><b>{{ $t('Prime.signin-step1-title', [$t('Prime.EEC-provider')]) }}</b> {{ $t('Prime.signin-step1-desc') }}</ion-label>
              </ion-item>
              <ion-item class="item-background" lines="none">
                <ion-checkbox :disabled="!(user.phoneValidatedDate && user.drivingLicenceNumber)" slot="start" :checked="checks[1]" @ionChange="switchCheck(1)"></ion-checkbox>
                <ion-label class="no-white-space"><b>{{ $t('Prime.signin-step2-title', [$t('Prime.EEC-provider')]) }}</b> {{ $t('Prime.signin-step2-desc') }}</ion-label>
              </ion-item>
              <ion-item class="item-background" lines="none">
                <ion-checkbox :disabled="!(user.phoneValidatedDate && user.drivingLicenceNumber)" slot="start" :checked="checks[2]" @ionChange="switchCheck(2)"></ion-checkbox>
                <ion-label class="no-white-space"><b>{{ $t('Prime.signin-step3-title') }}</b> {{ $t('Prime.signin-step3-desc') }}</ion-label>
              </ion-item>
              <ion-item class="item-background" lines="none">
                <ion-checkbox :disabled="!(user.phoneValidatedDate && user.drivingLicenceNumber)" slot="start" :checked="checks[3]" @ionChange="switchCheck(3)"></ion-checkbox>
                <ion-label class="no-white-space"><b>{{ $t('Prime.signin-step4-title') }}</b></ion-label>
              </ion-item>
              <ion-item class="item-background" lines="none">
                <ion-checkbox :disabled="!(user.phoneValidatedDate && user.drivingLicenceNumber)" slot="start" :checked="checks[4]" @ionChange="switchCheck(4)"></ion-checkbox>
                <ion-label class="no-white-space"><b>{{ $t('Prime.signin-step5-title') }}</b> {{ $t('Prime.signin-step5-desc', [$t('Prime.EEC-provider')]) }}</ion-label>
              </ion-item>
            </div>

            <br>

            <div >
              <ion-button class='mc-big-button' color="success" expand="block" :disabled="isChecked()" @click="mobConnect()">
                {{ $t('Prime.mob-connect') }} <img style="margin-left: 10px; margin-bottom: 10px;" height="20px" src="assets/mob.png"/>
              </ion-button>
                <div class="d-flex" justify-content-center align-items-center="">
                  <small>{{ $t('Prime.france-connect') }}</small>
                  <img style="margin-left: 10px" height="40px" src="assets/france-connect.png"/>
                </div>
            </div>
            <div>
              <p style="color: grey; font-size: 10px;">{{ $t('Prime.EEC-provider-siren') }}</p>
            </div>





          </div>

          <div v-if="step == 2">
            <div class="d-flex" justify-content-center>
              <ion-text color="primary"><b>{{ $t('Prime.informations')}}</b></ion-text>
            </div>
            <div class="d-flex" justify-content-center="">
              <div class="dot active"></div>
              <div class="dot active"></div>
              <div class="dot"></div>
            </div>
            <br>

            <div>
              {{ $t('Prime.informations-desc')}}
              <ul style="padding-inline-start: 12px;">
                <!-- todo iban status-->
                <li><div class="d-flex" justify-content-between="" align-items-center=""><div>{{ $t('Prime.informations-desc-1-start')}} <a @click="$router.push('bank-account')">{{ $t('Prime.informations-desc-1')}}</a></div> <ion-icon style="font-size: 18px" slot="end" color="success" v-if="bankAccount" name="checkmark"></ion-icon></div></li>
                <li><div class="d-flex" justify-content-between="" align-items-center=""><div>{{ $t('Prime.informations-desc-2-start')}} <a @click="$router.push('bank-account')">{{ $t('Prime.informations-desc-2')}}</a></div> <ion-icon style="font-size: 18px" slot="end" color="success" v-if="bankAccount && bankAccount.validationStatus == 1" name="checkmark"></ion-icon></div></li>
              </ul>
            </div>
          </div>

          <div v-if="step == 3">
            <div class="d-flex" justify-content-center>
              <ion-text color="primary"><b>{{ $t('Prime.suivi')}}</b></ion-text>
            </div>
            <div class="d-flex" justify-content-center="">
              <div class="dot active"></div>
              <div class="dot active"></div>
              <div class="dot active"></div>
            </div>
            <br>

            <div>
              <div>{{$t('Prime.prime-long')}}</div>
              <div style="margin-bottom: 10px;" >
                  <span class="mc-progress-bar-prime">
                    <b>{{(!!ceeSubscription && !!ceeSubscription.longDistanceSubscriptions) ? ceeSubscription.longDistanceSubscriptions.length : 0 }} / 3 {{$t('Prime.long')}}</b>
                  </span>
                <ion-progress-bar color="primary" :value="((!!ceeSubscription && !!ceeSubscription.longDistanceSubscriptions) ? ceeSubscription.longDistanceSubscriptions.length : 0 ) / 3" ></ion-progress-bar>
              </div>
              <small>
                <ul>
                  <li>{{$t("Prime.long-desc-1")}}</li>
                  <li>{{$t("Prime.long-desc-2")}}</li>
                </ul>
              </small>
            </div>
            <br>
            <div>
              <div>{{$t('Prime.prime-short')}}</div>
              <div style="margin-bottom: 10px;" >
                  <span class="mc-progress-bar-prime">
                    <b>{{(!!ceeSubscription && !!ceeSubscription.shortDistanceSubscriptions) ? ceeSubscription.shortDistanceSubscriptions.length : 0 }} / 10 {{$t('Prime.short')}}</b>
                  </span>
                <ion-progress-bar color="primary" :value="((!!ceeSubscription && !!ceeSubscription.shortDistanceSubscriptions) ? ceeSubscription.shortDistanceSubscriptions.length : 0 ) / 10" ></ion-progress-bar>
              </div>
              <small>
                <ul>
                  <li>{{$t("Prime.short-desc-1")}}</li>
                </ul>
              </small>
            </div>
            <div class="d-flex" justify-content-around="">
              <div style="max-width: 40%">
                <div class="text-center" style="font-size: 30px"><b>{{ceeSubscription.nbPendingProofs}}</b></div>
                <div class="text-center" style="line-height: 16px"><small>{{$t("Prime.validation")}}</small></div>
              </div>
              <div style="max-width: 40%">
                <div class="text-center" style="font-size: 30px"><b>{{ceeSubscription.nbRejectedProofs}}</b></div>
                <div class="text-center" style="line-height: 16px"><small>{{$t("Prime.refused")}}</small></div>
              </div>
            </div>
            <br>
            <ion-button
              class="mc-big-button"
              color="primary"
              expand="block"
              fill="outline"
              @click="goToPostCarpool()"
              id="postCarpoolButton"
            >{{ $t('HOME.postCarpool') }}</ion-button>

            <ion-button
              v-if="isCapacitor && canSeeDynamics"
              class="mc-big-button"
              color="primary"
              expand="block"
              fill="outline"
              @click="goToDynamic()"
            >{{ $t('HOME.dynamic') }}</ion-button>


          </div>

        </div>
      </div>
    </ion-content>
  </div>
</template>

<style lang="scss">



.mc-prime-container {
  // background-color: rgba(var(--ion-color-primary-rgb), 0.13) !important;
  color: black !important;
  margin: -20px;
  padding: 20px;
  min-height: 100%;

}

.item-background {
  --background: transparent !important;
}

.dot {
  height: 8px;
  width: 8px;
  margin: 8px 3px;
  border-radius: 4px;
  background: var(--ion-color-medium);

  &.active {
    background: var(--ion-color-primary);
  }
}

.signin {
  font-size: 12px;

  .no-white-space {
    font-size: 12px;
  }

}

.mc-progress-bar-prime {
  position: absolute;
  width: calc(100% - 40px);
  z-index: 1;
  text-align: center;
  margin-top: 3px;
}

</style>

<script>
  import {toast} from "../../Shared/Mixin/toast.mixin";
  import {required, minLength} from "vuelidate/lib/validators";
  import { address } from '../../Shared/Mixin/address.mixin';
  import Compressor from 'compressorjs';
  import {isPlatform} from "@ionic/core";
  import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser';


  export default {
    name: 'prime',
    data () {
      return {
        step: 1,
        loading: false,
        driverLicense: '',
        isCapacitor : isPlatform(window.document.defaultView, "capacitor"),
        canSeeDynamics: JSON.parse(process.env.VUE_APP_CAN_SEE_DYNAMICS),
        infoUrl: process.env.VUE_APP_MOB_INFO_URL,
        ceeSubscription: null,
        checks: [ false, false, false, false, false]
      }
    },
    mixins: [toast, address],
    props : [],
    created() {
      this.mySubscriptions();
    },
    validations: {
      driverLicense: {
        required,
        minLength: minLength(9)
      }
    },
    computed: {
      user: {
        get() {
          return this.$store.state.userStore.user;
        }
      },
      bankAccount() {
        return this.$store.state.paymentStore.bankAccount;
      },
    },
    methods: {
      switchCheck(index) {
        this.checks[index] = !this.checks[index]
        this.checks = Object.assign([], this.checks);
      },
      isChecked() {
        return this.checks.includes(false);
      },
      getBankAccount() {
        this.$store.dispatch('getBankAccount').then(res =>{
          this.bankAccount = res
          if ((this.ceeSubscription.longDistanceSubscriptions || this.ceeSubscription.shortDistanceSubscriptions) && this.bankAccount.validationStatus == 1) {
            this.step = 3;
            console.log('step3')
          }
        })
      },
      mobConnect() {
        // window.open('https://idp.preprod.moncomptemobilite.fr/auth/realms/mcm/protocol/openid-connect/auth?client_id=mobicoop_pub&redirect_uri=https://test.mobicoop.io/user/sso/eec-incentive/user/sso/login&state=mobConnect-test&response_mode=fragment&response_type=code&scope=openid&nonce=21a8befa-b65f-41c5-916b-29c9e8d70177', '_system');
        this.$store.dispatch('sso_connections', {eec: true}).then((res) => {
            if (res && res.length > 0) {
              let uri = res[0].uri;
              // uri = uri.replace('#', '%23').replace('/eec-incentive' , '/eec-incentive?mobicoop=true' ).replace('response_mode=query', 'response_mode=fragment' )  ;
              if (isPlatform(window.document.defaultView, "capacitor")) {
                this.openUrl(uri);
              } else {
                window.open(uri, '_system');
              }

            }
          }).catch((error) => {
            console.log(error)
            this.presentToast(this.$t("Commons.error"), "danger");
          })
      },
      openUrl(url) {
        InAppBrowser.create(url, '_system');
      },
      mySubscriptions() {
        this.$store.dispatch('my_cee_subscriptions').then((res) => {
          this.ceeSubscription = res[0];
          if (this.ceeSubscription.longDistanceSubscriptions || this.ceeSubscription.shortDistanceSubscriptions) {
            this.step = 2;
            this.getBankAccount();
          }
        }).catch((error) => {
          console.log(error)
          //this.presentToast(this.$t("Commons.error"), "danger");
        })
      },
    }
  }
</script>
